import { Box, Stack, Typography, Link } from '@mui/material';
import { alpha } from '@mui/material/styles';
import Iconify from '../iconify';

export default function InheritableFieldGroup({
  title,
  isInherited,
  onCustomize,
  onReset,
  inheritedCaption = 'Inherited from global',
  customizedCaption = 'Custom for this service',
  customizeLabel = 'Customize',
  resetLabel = 'Reset to global',
  children,
}) {
  return (
    <Stack
      sx={{
        border: 1,
        borderColor: 'divider',
        borderRadius: 1,
        px: 1.5,
        py: 1.25,
        gap: 1,
        bgcolor: 'background.paper',
      }}
    >
      <Stack
        direction="row"
        alignItems="center"
        justifyContent="space-between"
        spacing={1}
      >
        <Typography
          variant="caption"
          color="text.secondary"
          noWrap
          sx={{ minWidth: 0, fontSize: 13 }}
        >
          {title}
          <Box component="span" sx={{ color: 'text.disabled', mx: 0.75 }}>·</Box>
          <Box
            component="span"
            sx={{
              display: 'inline-block',
              px: 0.875,
              py: 0.125,
              borderRadius: 999,
              fontSize: 11,
              fontWeight: 700,
              lineHeight: 1.6,
              letterSpacing: 0.2,
              transition: (theme) =>
                theme.transitions.create(['background-color', 'color'], {
                  duration: 120,
                }),
              ...(isInherited
                ? {
                    bgcolor: (theme) => alpha(theme.palette.grey[500], 0.16),
                    color: 'text.secondary',
                  }
                : {
                    bgcolor: (theme) => alpha(theme.palette.primary.main, 0.16),
                    color: 'primary.main',
                  }),
            }}
          >
            {isInherited ? inheritedCaption : customizedCaption}
          </Box>
        </Typography>

        {isInherited ? (
          <Link
            component="button"
            type="button"
            variant="caption"
            onClick={onCustomize}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              whiteSpace: 'nowrap',
              fontWeight: 600,
              color: 'primary.main',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline' },
            }}
          >
            <Iconify icon="eva:edit-2-outline" width={12} />
            {customizeLabel}
          </Link>
        ) : (
          <Link
            component="button"
            type="button"
            variant="caption"
            onClick={onReset}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              whiteSpace: 'nowrap',
              fontWeight: 500,
              color: 'text.secondary',
              textDecoration: 'none',
              '&:hover': { textDecoration: 'underline', color: 'error.main' },
            }}
          >
            <Iconify icon="eva:refresh-fill" width={13} />
            {resetLabel}
          </Link>
        )}
      </Stack>

      <Box
        sx={{
          transition: (theme) =>
            theme.transitions.create(['opacity'], { duration: 120 }),
        }}
      >
        {children}
      </Box>
    </Stack>
  );
}
